var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 获取子组件中输入框的值:"+_vm._s(_vm.msg)+" "),_c('child',{ref:"child"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }